import { Typography } from "@material-ui/core";
import styled from "styled-components";

export const SecondaryData = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.secondaryData.fontWeight};
  font-size: ${({ theme }) => theme.typography.secondaryData.fontSize};
  color: ${({ theme }) => theme.palette.chart.lightGray1};
`;
